import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../Form/ItemModify';

@inject('inventoryManufacturerStore')
@observer
class InventoryManufacturerModify extends Component {

  render() {
    const { inventoryManufacturerStore, params} = this.props;
    return (
      <ItemModify
      title='Inventory Manufacturer'
      slug = '/inventory/manufacturer'
      store = {inventoryManufacturerStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text', readOnly : true, editOnly : true},
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'URL', key: 'url', type: 'text' },
        { label: 'Description', key: 'description', type: 'text' },
        { label: 'Address', key: 'address', type: 'text' },
      ]}
      params={params}
      />
    );
  }
}

export default InventoryManufacturerModify;



// WEBPACK FOOTER //
// ./src/components/Inventory/ManufacturerModify.js